import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { Alert, Button, Modal } from "@mantine/core";

import { DataEntryListing } from "../components";
import { logout } from "../firebase";

import {
  TransferConfig,
  TankIssueConfig,
  BulkReceiptConfig,
  TankReadingConfig,
  RefuelConfig,
} from "../components/listings/configurations";
import { CompanyDetails } from "./company-details";

export interface DashboardProps {
  auth: {
    claims: {
      admin?: boolean;
      companyId?: string;
      user_id?: string;
    };
  } | null | undefined;
}

export function Dashboard({ auth }: DashboardProps) {
  const { templateName } = useParams();
  const navigate = useNavigate();
  const [companyId, setCompanyId] = useState<string | undefined>();
  const [userId, setUserId] = useState<string | undefined>();
  const [error, setError] = useState<string | undefined>();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (auth) {
      if (auth.claims.admin) {
        setIsAdmin(true)
      }
      if (auth?.claims?.companyId) {
        setCompanyId(auth.claims.companyId);
        setUserId(auth.claims.user_id);
        setError(undefined);
      } else {
        setCompanyId(undefined);
        setError(
          `Onboarding incomplete. Go back to the CaptivaFuel app to complete onboarding.`
        );
      }
    } else {
      setCompanyId(undefined);
    }
  }, [auth]);

  return (
    <>{isAdmin && (
        companyId && (
          <>
            {!templateName && (
              <>
                <CompanyDetails companyId={companyId} />
              </>
            )}
            {templateName === "capturedFuelTankTransfer" && (
              <DataEntryListing
                companyId={companyId}
                displayConfig={TransferConfig}
                templateName="capturedFuelTankTransfer"
                header="Fuel transfers (tanks)"
              />
            )}
            {templateName === "capturedTankLevelReading" && (
              <DataEntryListing
                companyId={companyId}
                displayConfig={TankReadingConfig}
                templateName="capturedTankLevelReading"
                header="Tank readings"
              />
            )}
            {templateName === "capturedFuelTankIssue" && (
              <DataEntryListing
                companyId={companyId}
                displayConfig={TankIssueConfig}
                templateName="capturedFuelTankIssue"
                header="Onsite refuels"
              />
            )}
            {templateName === "capturedBulkFuelReceived" && (
              <DataEntryListing
                companyId={companyId}
                displayConfig={BulkReceiptConfig}
                templateName="capturedBulkFuelReceived"
                header="Bulk deliveries"
              />
            )}
            {templateName === "capturedRefuel" && (
              <DataEntryListing
                companyId={companyId}
                displayConfig={RefuelConfig}
                templateName="capturedRefuel"
                header="Roadside refuels"
              />
            )}
          </>
        )
      )}
      {userId && !isAdmin && (
        <Modal
          opened={true}
          withCloseButton={false}
          onClose={() => {}}
          title="Permission required"
        >
          Please ask another Admin to upgrade your account.
          <Button
              onClick={async () => {
                await logout();
                navigate("/", { replace: true });
              }}
              size="md"
              color="cap-navy"
              style={{marginTop: '1em'}}
            >
              Logout
            </Button>
        </Modal>
        // TODO ?give option to email request to Admin?
      )}
      {error && (
        <Alert title="Profile incomplete" color="red">
          {error}
        </Alert>
      )}
    </>
  );
}
